import React from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';
import { graphql, useStaticQuery, Link } from 'gatsby';
import { FormattedMessage } from 'gatsby-plugin-intl';

import Text from '@components/text';
import Date from '@components/date';

const Wrapper = tw.div`w-full lg:w-1/3 lg:mt-10`;

const Header = tw(Text)`mb-26`;

const Posts = tw.div`flex flex-wrap`;

const Post = tw.div`flex items-center w-full mb-26 md:w-1/2 md:pr-10 lg:pr-0 lg:w-full`;

const LinkImage = styled(Link)`
  min-width: 135px;
  ${tw`inline-block mr-12 md:mr-15`}
`;

const DateWrapper = tw(Text)`mt-5 opacity-60`;

const Recommended = ({ locale }) => {
  const { allSanityPost } = useStaticQuery(graphql`
    query {
      allSanityPost(
        filter: {Polecane: {eq: true}},
        sort: {fields: date, order: DESC}
      ) {
        nodes {
          id
          title_pl
          title_en
          slug_pl {
            current
          }
          slug_en {
            current
          }
          mask_small {
            asset {
              fluid(maxWidth: 150) {
                ...GatsbySanityImageFluid
              }
            }
          }
          date
        }
      }
    }
  `);

  const pagePath = locale === 'en' ? '/en/post/' : '/post/';
  const postPath = (path) => `${pagePath}${path}`;

  return (
    <Wrapper>
      <Header color="redBlog" fontSizes={16} lineHeight={1.88}>
        <FormattedMessage id="blog.recommended posts" />
      </Header>
      <Posts>
        {allSanityPost.nodes.map((post) => (
          <Post key={post.id}>
            <LinkImage to={postPath(post[`slug_${locale}`].current)}>
              <Img fluid={post.mask_small.asset.fluid} />
            </LinkImage>
            <div>
              <Link to={postPath(post[`slug_${locale}`].current)}>
                <Text fontSizes={16} lineHeight={1.38}>
                  {post[`title_${locale}`]}
                </Text>
              </Link>
              <DateWrapper fontSizes={14} fontWeight={300} lineHeight={1.57}>
                <Date date={post.date} locale={locale} />
              </DateWrapper>
            </div>
          </Post>
        ))}
      </Posts>
    </Wrapper>
  );
};

Recommended.propTypes = {
  locale: PropTypes.string.isRequired,
};

export default Recommended;
